const configuration = {
  PRIMARY_SERVER_URL: process.env.REACT_APP_PRIMARY_SERVER_URL,
  FIREBASE: {
    apiKey: 'AIzaSyDhARpv2VKNtWTJ3w5AVDJPON6bS9i93EI',
    authDomain: 'sse-um-ptkin.firebaseapp.com',
    projectId: 'sse-um-ptkin',
    storageBucket: 'sse-um-ptkin.appspot.com',
    messagingSenderId: '984741239808',
    appId: '1:984741239808:web:07d8a0c52f0ae2f6408ce5',
    measurementId: 'G-J4RR2TE0SF',
  },
  FIREBASE_SENDER_ID: '984741239808',
  SIMULASI_SHARED_SECRET:
    '09b8667546682c646ed8dd733e50f6d639f8f6fc9754b8a3e98feee2f6adf992',

  // Jeda waktu agar tombol refresh dapat ditekan.
  REFRESH_BREAK_TIME: 20, // In seconds
  REFRESH_QUESTION_BREAK_TIME: 20, // In seconds

  SIMULATE_DURATION: 60 * 10, // 10 minutes (dalam satuan detik).

  MAX_RECORD_DURATION: 30, // In seconds

  // Offline simulation
  OFFLINE_SIMULATION: false,
};

export default configuration;
